import { createAuthClient } from 'better-auth/react';
import { organizationClient, twoFactorClient } from 'better-auth/client/plugins';

function getBaseURL(): string {
  const apiUrl = import.meta.env.VITE_API_BASE_URL;
  if (!apiUrl) return window.location.origin;
  try {
    return new URL(apiUrl).origin;
  } catch {
    console.warn(
      `[auth-client] Invalid VITE_API_BASE_URL: "${apiUrl}" — falling back to same-origin`,
    );
    return window.location.origin;
  }
}

export const authClient = createAuthClient({
  baseURL: getBaseURL(),
  fetchOptions: {
    credentials: 'include',
  },
  plugins: [
    organizationClient(),
    twoFactorClient({
      onTwoFactorRedirect: () => {
        window.location.href = '/verify-2fa';
      },
    }),
  ],
});

export const { useSession, signIn, signUp, signOut, organization: organizationApi } = authClient;
